export default __webpack_public_path__ + "static/media/copy-white.25fd5146.svg";